import React from "react";
import SectionExternalSignPostCards from "../../../containers/sections/SectionExternalSignPostCards";

interface ParagraphExternalSignpostLinkProps {
	items: DogsTrust.SignPostCardProps[];
}

export const getParagraphExternalSignpostLinkProps = ({
	relationships: { field_ex_signpost_content },
}: Queries.ParagraphExternalSignpostLinkDataFragment): ParagraphExternalSignpostLinkProps => ({
	items: field_ex_signpost_content.map(
		(externalLink) =>
			({
				title: externalLink.title,
				body: externalLink.field_external_signpost_summary,
				buttonLabel: externalLink.field_link.title,
				externalUrl: externalLink.field_link.uri,
				imgSrc:
					externalLink.relationships?.field_image?.field_media_image?.uri || "",
				label: externalLink.relationships?.field_image?.field_media_image.alt,
			}) as DogsTrust.SignPostCardProps,
	),
});
export const ParagraphExternalSignpostLink: React.FC<
	ParagraphExternalSignpostLinkProps
> = ({ items }) => {
	return <SectionExternalSignPostCards items={items} />;
};

export default ParagraphExternalSignpostLink;
